import { USER_ROLES } from '../../../common/globalConstants';

export const loginUrl = '/login';

export const navMenus = [
  {
    path: '/dashboard/harmwatch',
    name: 'Hot Posts',
    iconImage: 'hot_posts.svg',
    iconImageAltText: 'Hot Posts',
    roles: [USER_ROLES.ADMIN, USER_ROLES.DATA_ANALYST],
  },
  {
    path: '/dashboard/topics',
    name: 'Topics',
    iconImage: 'topics.svg',
    iconImageAltText: 'Topics',
    roles: [USER_ROLES.ADMIN, USER_ROLES.DATA_ANALYST],
  },
  {
    path: '/dashboard/sources',
    name: 'sources',
    icon: 'link',
    roles: [USER_ROLES.ADMIN, USER_ROLES.DATA_ANALYST],
  },
  {
    path: '/dashboard/reports',
    name: 'reports',
    iconImage: 'reports.svg',
    iconImageAltText: 'Reports',
    roles: [USER_ROLES.ADMIN, USER_ROLES.DATA_ANALYST],
  },
  {
    path: '/dashboard/user-management',
    name: 'user ',
    icon: 'user-cog',
    roles: [USER_ROLES.ADMIN],
  },
];



// WEBPACK FOOTER //
// ./src/features/shared-components/navigation-bar/navigation-bar-constants.js